export default __webpack_public_path__ + "static/media/ryd_2.441d001a.webp";